/* 


@PRAKT


   _____________________________________________________________

   |
   | GLOBALS
   |
   _____________________________________________________________
*/

/*::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
::
:: RESPONSIVE BREAKPOINTS (BASED ON BOOTSTRAP)
::
::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::*/

global.BREAKPOINT_XXS = 320;
global.BREAKPOINT_XS = 375;
global.BREAKPOINT_SM = 768;
global.BREAKPOINT_MD = 992;
global.BREAKPOINT_LG = 1200;
global.BREAKPOINT_XL = 1400;
global.BREAKPOINT_XXL = 1600;
global.DEV_MODE = false;